import React, { memo } from 'react';
import { CalendarIcon, BadgeCheckIcon } from '@heroicons/react/outline';
import ConfettiBoom, { ConfettiProps } from 'react-confetti-boom';
import PermissionsView from './PermissionsView';

const ConfettiBoomRenderer = ConfettiBoom as React.FC<ConfettiProps>;

interface ThankYouProps {}

const ThankYou: React.FC<ThankYouProps> = () => {
  return (
    <>
      <div>
        <div className="text-center">
          {/* Success Icon */}
          <div className="flex justify-center mb-8">
            <div className="text-[75px] rounded-full">🎉</div>
          </div>
          <ConfettiBoomRenderer mode="boom" particleCount={200} />
          {/* Main Thank You Message */}
          <h2 className="flex items-center justify-center text-4xl font-bold text-gray-900 mb-4">
            <BadgeCheckIcon className="w-10 h-10 text-green-600 mr-2" /> You’re
            Almost There — One Final Step
          </h2>

          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Thanks for completing the setup guide! Your store is now configured
            and ready for installation.
          </p>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            To go live, simply approve the Shopify permissions when you receive
            the request. Once approved, we’ll complete the expert install
            directly in your store.
          </p>
        </div>

        {/* Permissions Summary Box */}
        <PermissionsView />

        <div className="w-full h-[0.2px] bg-gray-300 my-4"></div>

        {/* Strategy Call */}
        <div className="flex justify-start gap-2 my-5 mx-auto w-[85%]">
          <div className="mr-5">
            <iframe
              width="200"
              src="https://www.youtube.com/embed/Y-gBNh4r6Wo?rel=0"
              title="Optimized For Conversions"
              allow="accelerometer; autoplay;"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>
          <div className="text-left">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Want to Maximize Conversions & Revenue?
            </h2>
            <p className="text-gray-600 mb-8">
              Book a free strategy call with our team. We’ll help you optimize
              widget placement, increase opt-in rates, and reduce post-purchase
              support headaches.
            </p>
            <button
              onClick={() =>
                window.open('https://calendly.com/shipaid/onboarding', '_blank')
              }
              className="inline-flex items-center px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-200"
            >
              <CalendarIcon className="mr-2 w-8 h-8" />
              Schedule Strategy Call
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(ThankYou);
